import React from "react";
import { Route, Redirect  } from "react-router-dom";

export default function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={() => {
        return localStorage.getItem("isLogedin") ? (
          children
        ) : (
          <Redirect to='/Login'></Redirect>
        );
      }}
    ></Route>
  );
}
